module.exports = __webpack_public_path__ + "img/phone.05894b32.png";